/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_RevokeInputs */

const en_share_revoke = /** @type {(inputs: Share_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revoke link`)
};

const de_share_revoke = /** @type {(inputs: Share_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link zurückziehen`)
};

/**
* | output |
* | --- |
* | "Revoke link" |
*
* @param {Share_RevokeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const share_revoke = /** @type {((inputs?: Share_RevokeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_RevokeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_share_revoke(inputs)
	return en_share_revoke(inputs)
});